import { render, staticRenderFns } from "./ProfilePopup.vue?vue&type=template&id=40667474"
import script from "./ProfilePopup.vue?vue&type=script&lang=js"
export * from "./ProfilePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports